import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { ScanShipmentsStateModel } from 'src/app/features/model/hawb.model';
import {
  ClearScanSession,
  RecordScan,
  ResetScanSession,
  SetCanvasAlerts,
  SetHistoryFilter,
  SetVoiceFeedback,
} from './hawb.action';

export const defaultScanShipmentsState: ScanShipmentsStateModel = {
  history: [],
  lastScanned: null,
  voiceFeedback: true,
  canvasAlerts: true,
  filter: 'All',
};

/**
 * SPEC-SSS-001 FR-SSS-UI-015: the scan session lives in memory only and only while
 * the page is open; leaving the page clears it, and a refresh or logout reloads the app.
 */
@State<ScanShipmentsStateModel>({
  name: 'scanShipments',
  defaults: defaultScanShipmentsState,
})
@Injectable()
export class ScanShipmentsState {
  @Action(RecordScan)
  recordScan(ctx: StateContext<ScanShipmentsStateModel>, action: RecordScan) {
    const { history } = ctx.getState();
    const record = { ...action.payload, scanId: (history[0]?.scanId ?? 0) + 1 };
    ctx.patchState({ history: [record, ...history], lastScanned: record });
  }

  @Action(ResetScanSession)
  resetScanSession(ctx: StateContext<ScanShipmentsStateModel>) {
    ctx.patchState({ history: [], lastScanned: null, filter: 'All' });
  }

  @Action(ClearScanSession)
  clearScanSession(ctx: StateContext<ScanShipmentsStateModel>) {
    ctx.setState(defaultScanShipmentsState);
  }

  @Action(SetVoiceFeedback)
  setVoiceFeedback(
    ctx: StateContext<ScanShipmentsStateModel>,
    action: SetVoiceFeedback
  ) {
    ctx.patchState({ voiceFeedback: action.payload });
  }

  @Action(SetCanvasAlerts)
  setCanvasAlerts(
    ctx: StateContext<ScanShipmentsStateModel>,
    action: SetCanvasAlerts
  ) {
    ctx.patchState({ canvasAlerts: action.payload });
  }

  @Action(SetHistoryFilter)
  setHistoryFilter(
    ctx: StateContext<ScanShipmentsStateModel>,
    action: SetHistoryFilter
  ) {
    ctx.patchState({ filter: action.payload });
  }
}
